import { __DEV__ } from '@mote/helpers/constants'
import { mergeClassnames } from '@mote/helpers/dom'
import type { SystemProps } from '@xstyled/styled-components'
import { x } from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'

type Variant = 'wide' | 'narrow' | 'default'

const variants: Record<Variant, SystemProps> = {
  wide: {
    maxWidth: '1600px',
    px: { xs: 6, sm: 4 }
  },
  narrow: {
    maxWidth: '992px',
    px: { xs: 6, sm: 4 }
  },
  default: {
    maxWidth: '1400px',
    px: { xs: 10, md: '60rpx', lg: '30rpx' }
  }
}

export interface ContainerProps extends HTMLXStyledProps<'div'> {
  variant?: Variant
  centered?: boolean
}

export const Container = forwardRef<ContainerProps, 'div'>(
  ({ className, variant, centered, ...props }, ref) => {
    const variantProps = variants[variant || 'default']

    return (
      <x.div
        ref={ref}
        className={mergeClassnames('mote-container', className)}
        mx='auto'
        w='full'
        {...variantProps}
        {...props}
        {...(centered && {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        })}
      />
    )
  }
)

if (__DEV__) {
  Container.displayName = 'Container'
}
